<template>
  <div>

    <a-spin :spinning="spinning">
      <a-card style="margin-top: 30px">
        <a-row type="flex">
          <a-col :span="4">
            <span>
              <span class="title">{{ $t('message.uploadGroup.title3') }}：</span>
              <span class="value">{{
                  showThousandNum(this.peopleInfo.user_count)
                }}</span>
            </span>
          </a-col>
        </a-row>

        <a-form-model
            style="margin-top: 36px"
            ref="updUserRuleForm"
            :model="uploadGroupForm"
            :label-col="{ span: 4 }"
            :wrapper-col="{ span: 16 }"
            :rules="rules"
        >
          <a-form-model-item :label="$t('message.uploadGroup.title4')" prop="flag">
            <a-radio-group :size="$globalSize" v-model="uploadGroupForm.flag">
              <a-radio value="1">{{ $t('message.uploadGroup.title5') }}</a-radio>
              <a-radio value="2">{{ $t('message.uploadGroup.title6') }}</a-radio>
            </a-radio-group>
          </a-form-model-item>

          <a-form-model-item
              v-if="uploadGroupForm.flag!==1"
              :label="$t('message.uploadGroup.title7')"
              prop="group_id"
          >
            <a-input-number :size="$globalSize"
                style="width: 100%"
                :min="0"
                :max="9007199254740992"
                :step="1"
                :placeholder="$t('message.uploadGroup.title8')"
                allowClear
                v-model="uploadGroupForm.group_id"
            ></a-input-number>
          </a-form-model-item>
          <a-form-model-item :label="$t('message.uploadGroup.title9')" prop="group_name">
            <a-input :size="$globalSize"
                :placeholder="$t('message.uploadGroup.title10')"
                allowClear
                v-model="uploadGroupForm.group_name"
            ></a-input>
          </a-form-model-item>
          <a-form-model-item :label="$t('message.uploadGroup.title11')" prop="group_sql">
            <a-textarea :size="$globalSize"
                :rows="5"
                :placeholder="$t('message.uploadGroup.title12')"
                allowClear
                v-model="uploadGroupForm.group_sql"
            ></a-textarea>
          </a-form-model-item>
        </a-form-model>
        <a-row style="text-align: center">
          <a-button  :size="$globalSize" 
              type="primary"
              @click="uploadGroupClick"
              style="text-align: center"
          >
            {{ $t('message.uploadGroup.title2') }}
          </a-button>
        </a-row>
      </a-card>
    </a-spin>
  </div>
</template>
<script>
import utils from "@/utils";
import userGroupListService from "@/interface/pages/UserGroup/userList";

export default {
  name: "UploadGroup",
  data() {
    return {
      peopleInfo: {
        user_count: 0,
      },
      spinning: false,
      rules: {
        group_id: [
          {required: true, message: () => this.$t('message.uploadGroup.title8'), trigger: "blur"},
        ],
        group_name: [
          {required: true, message: () => this.$t('message.uploadGroup.title10'), trigger: "blur"},
        ],
        group_sql: [
          {required: true, message: () => this.$t('message.uploadGroup.title12'), trigger: "blur"},
        ],
        flag: [
          {required: true, message: () => this.$t('message.uploadGroup.title13'), trigger: "blur"},
        ],
      },
      uploadGroupForm: {
        group_name: "",
        group_sql: "",
        flag: "1",
      },
    };
  },
  mounted() {
    let params = this.$route.params;
    if (params.group_id) {
      this.peopleInfo.user_count = params.user_count;
    } else {
      this.peopleInfo.user_count = 0;
    }
  },
  methods: {
    uploadGroupClick() {
      this.$refs.updUserRuleForm.validate((valid) => {
        if (valid) {
          this.uploadGroupAjax();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    uploadGroupAjax() {
      this.spinning = true;
      let param = {
        group_name: this.uploadGroupForm.group_name,
        group_sql: this.uploadGroupForm.group_sql,
      };
      if (this.uploadGroupForm.flag != "1") {
        param.group_id = this.uploadGroupForm.group_id;
      }
      userGroupListService
          .uploadGroupAjax(this, {data: param})
          .then(
              function (resp) {
                var res = resp.data;
                if (res.code == "200") {
                  this.spinning = true;
                  this.$message.success(res.message);
                } else {
                  this.$message.error(res.message);
                }
                this.uploadGroupForm = {
                  flag: "1",
                };
              }.bind(this)
          )
          .catch((reason) => {
            console.log(reason);
          })
          .finally(() => {
            this.spinning = false;
          });
    },
    showThousandNum(value) {
      return utils.showThousandNumber(value);
    },
  },
};
</script>
<style scoped>
.title {
  font-weight: 600;
}

.value {
  padding-left: 6px;
}
</style>